import requests from "./httpService";

const FixedItineraryPeriodicHikeServices = {
  getAllFixedItineraryPeriodicHike: async (body) => {
    return requests.get(`/fixedItineraryPeriodicHike/`);
  },

  addFixedItineraryPeriodicHike: async (body) => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date), 
      end_date: formatDate(body.end_date),
    };
    return requests.post(`/fixedItineraryPeriodicHike/add`, formattedBody);
  },
  getFixedItineraryPeriodicHikeById: async (id) => {

    return requests.get(`/fixedItineraryPeriodicHike/${id}`);
  },

  updateFixedItineraryPeriodicHike: async (id, body) => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date), 
      end_date: formatDate(body.end_date),
    };
    return requests.put(`/fixedItineraryPeriodicHike/update/${id}`, formattedBody);
  },

  deleteFixedItineraryPeriodicHike: async (id) => {
    return requests.delete(`/fixedItineraryPeriodicHike/delete/${id}`);
  },
};

export default FixedItineraryPeriodicHikeServices;
